<app-scw-formio-builder [initialForm]="initialForm" (editedForm)="setEditedForm($event)"></app-scw-formio-builder>
